import { JagmRootProvider } from "@incartdev/jagm-core";
import { JagmRawLineSignalData, JagmRawSignalsChartProvider } from "@incartdev/jagm-chart";
import { RawOfflineVisualizatorConfigJsUnpacker } from "@incartdev/jagm-visualizator";

class GraphLibAdapter {
    visProvider;
    chartProvider;
    visualSettings;
    canvasRef;
    valueConverter;
    fd;

    constructor(props) {
        this.visualSettings = props.visualSettings;
        this.canvasRef = props.canvasRef;
        this.visProvider = new JagmRootProvider(new RawOfflineVisualizatorConfigJsUnpacker());
        this.fd = props.fd;
    }

    async initializeGraph() {
        await this.visProvider.create({
            settings: this.visualSettings,
            rootHtml: this.canvasRef
        });

        this.chartProvider = new JagmRawSignalsChartProvider(this.visProvider.builder);

        const chart = this.chartProvider.charts[0];
        const signals = chart.findContentGroup("signals");
        this.valueConverter = signals.valueConverter;
    }

    plotData = async plotData => {
        const praparedPlotData = new JagmRawLineSignalData(plotData);

        for (let signalGroupIndex = 0; signalGroupIndex < this.chartProvider.signalObjectGroups.length; ++signalGroupIndex) {
            const signalGroup = this.chartProvider.signalObjectGroups[signalGroupIndex];
            await signalGroup.clearSignalData(0, 0, 0);
            await signalGroup.addSignalData(0, 0, 0, praparedPlotData);
        }
        this.visProvider.refreshGraphics();
    };

    setUserSweepUnits = text => {
        this.chartProvider.charts.forEach(chart => {
            const scalesGroup = chart.findContentGroup("scales");
            if (scalesGroup === undefined) return;
            scalesGroup.setUserSweepUnits(text);
        });
    };

    getWidthInPoints = fd => {
        const widths = this.chartProvider.signalObjectGroups.map(signalGroup => signalGroup.getSignalsWidthInPoints(fd));
        return widths[0];
    };

    changeScaleX = type => {
        if (this.chartProvider === undefined) {
            return;
        }
        let index = undefined;
        this.chartProvider.charts.forEach(chart => {
            const signalGroup = chart.findContentGroup("signals");
            if (signalGroup === undefined) return;
            const scaleConfig = signalGroup.config.axis.x.scale;
            const currIndex = scaleConfig.currIndex;

            switch (type) {
                case "increase": {
                    if (currIndex < scaleConfig.values.length - 1) {
                        scaleConfig.currIndex++;
                        signalGroup.setScaleX();
                    }
                    break;
                }
                case "decrease": {
                    if (currIndex > 0) {
                        scaleConfig.currIndex--;
                        signalGroup.setScaleX();
                    }
                    break;
                }
                default: {
                    console.warn(`Неизвестный тип масштаба ${type}`);
                }
            }
            index = scaleConfig.currIndex;
        });

        return index;
    };

    changeScaleY = async type => {
        if (this.chartProvider === undefined) {
            return;
        }
        const promises = [];
        let index = undefined;
        this.chartProvider.charts.forEach(chart => {
            let promise;
            const signalGroup = chart.findContentGroup("signals");
            if (signalGroup === undefined) return;
            const scaleConfig = signalGroup.config.axis.y.scale;
            const currIndex = scaleConfig.currIndex;

            switch (type) {
                case "increase": {
                    if (currIndex < scaleConfig.values.length - 1) {
                        scaleConfig.currIndex++;
                        promise = signalGroup.setScaleY();
                    }
                    break;
                }
                case "decrease": {
                    if (currIndex > 0) {
                        scaleConfig.currIndex--;
                        promise = signalGroup.setScaleY();
                    }
                    break;
                }
                default: {
                    console.warn(`Неизвестный тип масштаба ${type}`);
                }
            }

            index = scaleConfig.currIndex;
            promises.push(promise);
        });

        await Promise.all(promises);
        this.visProvider.refreshGraphics();

        return index;
    };

    convertMsToPixels = ms => {
        let msInMm = this.getSweepScaleInMs();
        const ms_px_coeff = this.valueConverter.convertMmToPixels(1, this.fd) * msInMm;
        return ms * ms_px_coeff;
    };

    convertPixelsToMs = pixels => {
        let msInMm = this.getSweepScaleInMs();
        return Math.round(this.valueConverter.convertPixelsToMm(pixels, this.fd) / msInMm);
    };

    getSweepScaleInMs = () => {
        let msInMm = 0;
        this.chartProvider.signalObjectGroups.forEach(signalGroup => {
            msInMm = signalGroup.config.axis.x.scale?.getCurrValue() / 1000;
        });

        return msInMm;
    };

    changeDefaultFrequencySettungs = frequency => {
        this.visualSettings.data.channels.forEach(channel => {
            channel.frequency = frequency;
        });
    };

    onResize = callback => {
        this.chartProvider.rootObject.addEventListener("CanvasSizeChanged", callback);
    };
}

export default GraphLibAdapter;
